import type { NavProps } from "@/components/nav/types";
import type { NavItemDataProps } from "@/components/nav/types";

export function filterNavByPermissions(
	data: NavProps["data"],
	permissions: string[],
): NavProps["data"] {
	return data
		.map((group) => {
			const filteredItems = group.items
				.map((item) => {
					const filteredChildren = item.children?.filter((child) => {
						if (!child.permission) return true;
						if (Array.isArray(child.permission)) {
							return child.permission.some((p) => permissions.includes(p));
						}
						return permissions.includes(child.permission);
					});

					if (item.children && (!filteredChildren || filteredChildren.length === 0)) {
						return null;
					}

					return { ...item, children: filteredChildren };
				})
				.filter(Boolean) as NavItemDataProps[];

			if (filteredItems.length === 0) return null;
			return { ...group, items: filteredItems };
		})
		.filter(Boolean) as NavProps["data"];
}
